import React from "react";

interface LoaderProps {
  size?: "sm" | "md" | "lg" | "xl";
  text?: string;
  fullScreen?: boolean;
  showText?: boolean;
}

const Loader: React.FC<LoaderProps> = ({
  size = "md",
  text = "Loading...",
  fullScreen = false,
  showText = true,
}) => {
  // Size configs
  const sizeClasses: Record<string, string> = {
    sm: "w-6 h-8",
    md: "w-10 h-12",
    lg: "w-16 h-20",
    xl: "w-24 h-28",
  };

  const DocumentLoader = () => (
    <div className="relative">
      <div
        className={`${sizeClasses[size]} border-2 border-blue-500 rounded-lg bg-white relative overflow-hidden`}
      >
        {/* Document lines */}
        <div className="absolute top-2 left-2 right-2 h-1 bg-gray-200 rounded"></div>
        <div className="absolute top-4 left-2 right-4 h-1 bg-gray-200 rounded"></div>
        <div className="absolute top-6 left-2 right-6 h-1 bg-gray-200 rounded"></div>

        {/* Shimmer effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-blue-100 to-transparent animate-pulse"></div>
      </div>

      {/* Ping dot indicator */}
      <div className="absolute -top-1 -right-1 w-3 h-3 bg-blue-600 rounded-full animate-ping"></div>
    </div>
  );

  const LoaderContent = () => (
    <div className="flex flex-col items-center justify-center space-y-4">
      <DocumentLoader />
      {showText && (
        <div className="text-blue-600 font-medium text-sm animate-pulse">
          {text}
        </div>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white bg-opacity-90 backdrop-blur-sm flex items-center justify-center z-50">
        <LoaderContent />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-4">
      <LoaderContent />
    </div>
  );
};

export default Loader;